// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment__s6u9p {
  color: var(--tables-primary-row-text-main);
  position: relative;
  padding-left: 30px;
}

.commentUserAvatar__SebBT {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
}

.commentHead__uxity {
  font-size: 10px;
  line-height: 12px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.commentDate__X0qxS {
  color: var(--tables-primary-row-text-additional);
}

.translateBtn__bvEvv {
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  position: relative;
  top: 0;
  right: 0;
  cursor: pointer;
}

.translateBtnText__vJ4bd {
  font-size: 12px;
  line-height: 12px;
  background-color: transparent;
  color: var(--buttons-text-secondary);
  text-decoration: none;
  margin-left: 10px;
  cursor: pointer;
}

@media (max-width: 810px) {
  .translateIcon__HOOy0 {
    width: 18px;
  }
}

.commentInfo__kBm1f {
  display: flex;
  align-items: center;
  column-gap: 10px;
  row-gap: 5px;
  flex-wrap: wrap;
}

.commentAuthor__LJtoj {
  font-weight: 500;
  line-height: 18px;
  color: var(--tables-primary-row-text-main);
  text-transform: uppercase;
}

.commentEdited__a1e0r {
  font-size: 10px;
  color: var(--tables-secondary-row-sub-title-text);
}

.commentBody__raH24 {
  font-size: 12px;
  line-height: 18px;
  color: var(--tables-primary-row-text-main);
  margin-top: 7px;
}
.commentBody__raH24 p {
  margin-bottom: 15px;
}
.commentBody__raH24 img {
  cursor: zoom-in;
}

.commentBodyFiles__xqAub {
  margin-top: 12px;
  padding: 5px 11px 12px;
  background: var(--tables-title-surface);
  border-radius: 5px;
}

.fileItem__A6kJ2 {
  margin-top: 10px;
  padding: 10px 15px;
  border-radius: 2px;
  background: var(--tables-secondary-row-sub-title-surface);
  text-decoration: none;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.fileItem__A6kJ2:not(:last-child) {
  margin-bottom: 18px;
}
.fileItem__A6kJ2 svg {
  width: 24px;
  height: 24px;
}
.fileItem__A6kJ2 svg path {
  stroke: var(--buttons-surface);
}
.fileItem__A6kJ2 .file-type {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}

.fileItemName__Gprab {
  color: var(--tables-secondary-row-sub-title-text);
  margin-left: 10px;
}

.commentMessage__fcCBr p {
  margin: 0;
  word-break: break-word;
}
.commentMessage__fcCBr a {
  color: var(--buttons-surface-2);
  background: transparent !important;
}
.commentMessage__fcCBr img {
  width: 100% !important;
  height: 100%;
  object-fit: contain;
}

.commentActions__bAVeK {
  display: flex;
  column-gap: 3px;
}

.editCommentIcon__f_EFK {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.editCommentIcon__f_EFK:focus, .editCommentIcon__f_EFK:active {
  outline: none;
}
@media print {
  .editCommentIcon__f_EFK {
    overflow: hidden;
    height: 0;
  }
}

.extraBlock__wVqtT {
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: var(--buttons-text-secondary);
  margin-top: 5px;
  text-transform: uppercase;
  background: var(--tables-primary-row-surface-default);
  border: none;
  cursor: pointer;
}
@media print {
  .extraBlock__wVqtT {
    overflow: hidden;
    height: 0;
  }
}

.arrowIcon__NsbOv {
  stroke: var(--buttons-surface);
  margin-left: 5px;
  transition: all 0.3s ease-in-out;
}

.arrowTop__Dxo9l {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/UserMessage/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,0CAAA;EACA,kBAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,gDAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;AAzEF;;AA6EE;EADF;IAEI,WAAA;EAzEF;AACF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iDAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,eAAA;AAzEF;AA4EI;EACE,mBAAA;AA1EN;AA4EI;EACE,eAAA;AA1EN;;AA+EA;EACE,gBAAA;EACA,sBAAA;EACA,uCAAA;EACA,kBAAA;AA5EF;;AA+EA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yDAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AA5EF;AA8EE;EACE,mBAAA;AA5EJ;AA+EE;EACE,WAAA;EACA,YAAA;AA7EJ;AA+EI;EACE,8BAAA;AA7EN;AAkFI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAhFN;;AAoFA;EACE,iDAAA;EACA,iBAAA;AAjFF;;AAsFI;EACE,SAAA;EACA,sBAAA;AAnFN;AAsFI;EACE,+BAAA;EACA,kCAAA;AApFN;AAuFI;EACE,sBAAA;EACA,YAAA;EACA,mBAAA;AArFN;;AA0FA;EACE,aAAA;EACA,eAAA;AAvFF;;AA0FA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAvFF;AAyFE;EAEE,aAAA;AAxFJ;AA2FE;EAVF;IAWI,gBAAA;IACA,SAAA;EAxFF;AACF;;AA2FA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,qDAAA;EACA,YAAA;EACA,eAAA;AAxFF;AA0FE;EAXF;IAYI,gBAAA;IACA,SAAA;EAvFF;AACF;;AA0FA;EACE,8BAAA;EACA,gBAAA;EACA,gCAAA;AAvFF;;AA0FA;EACE,yBAAA;AAvFF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.comment {\n  color: var(--tables-primary-row-text-main);\n  position: relative;\n  padding-left: 30px;\n}\n\n.commentUserAvatar {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 50%;\n}\n\n.commentHead {\n  font-size: 10px;\n  line-height: 12px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.commentDate {\n  color: var(--tables-primary-row-text-additional);\n}\n\n.translateBtn {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 12px;\n  text-transform: capitalize;\n  display: flex;\n  align-items: center;\n  position: relative;\n  top: 0;\n  right: 0;\n  cursor: pointer;\n}\n\n.translateBtnText {\n  font-size: 12px;\n  line-height: 12px;\n  background-color: transparent;\n  color: var(--buttons-text-secondary);\n  text-decoration: none;\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n.translateIcon {\n  @media (max-width: 810px) {\n    width: 18px;\n  }\n}\n\n.commentInfo {\n  display: flex;\n  align-items: center;\n  column-gap: 10px;\n  row-gap: 5px;\n  flex-wrap: wrap;\n}\n\n.commentAuthor {\n  font-weight: 500;\n  line-height: 18px;\n  color: var(--tables-primary-row-text-main);\n  text-transform: uppercase;\n}\n\n.commentEdited {\n  font-size: 10px;\n  color: var(--tables-secondary-row-sub-title-text);\n}\n\n.commentBody {\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--tables-primary-row-text-main);\n  margin-top: 7px;\n\n  :global {\n    p {\n      margin-bottom: 15px;\n    }\n    img {\n      cursor: zoom-in;\n    }\n  }\n}\n\n.commentBodyFiles {\n  margin-top: 12px;\n  padding: 5px 11px 12px;\n  background: var(--tables-title-surface);\n  border-radius: 5px;\n}\n\n.fileItem {\n  margin-top: 10px;\n  padding: 10px 15px;\n  border-radius: 2px;\n  background: var(--tables-secondary-row-sub-title-surface);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  &:not(:last-child) {\n    margin-bottom: 18px;\n  }\n\n  svg {\n    width: 24px;\n    height: 24px;\n\n    path {\n      stroke: var(--buttons-surface);\n    }\n  }\n\n  :global {\n    .file-type {\n      width: 20px;\n      height: 20px;\n      margin-right: 12px;\n    }\n  }\n}\n.fileItemName {\n  color: var(--tables-secondary-row-sub-title-text);\n  margin-left: 10px;\n}\n\n.commentMessage {\n  :global {\n    p {\n      margin: 0;\n      word-break: break-word;\n    }\n\n    a {\n      color: var(--buttons-surface-2);\n      background: transparent !important;\n    }\n\n    img {\n      width: 100% !important;\n      height: 100%;\n      object-fit: contain;\n    }\n  }\n}\n\n.commentActions {\n  display: flex;\n  column-gap: 3px;\n}\n\n.editCommentIcon {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n\n  &:focus,\n  &:active {\n    outline: none;\n  }\n\n  @media print {\n    overflow: hidden;\n    height: 0;\n  }\n}\n\n.extraBlock {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--buttons-text-secondary);\n  margin-top: 5px;\n  text-transform: uppercase;\n  background: var(--tables-primary-row-surface-default);\n  border: none;\n  cursor: pointer;\n\n  @media print {\n    overflow: hidden;\n    height: 0;\n  }\n}\n\n.arrowIcon {\n  stroke: var(--buttons-surface);\n  margin-left: 5px;\n  transition: all 0.3s ease-in-out;\n}\n\n.arrowTop {\n  transform: rotate(180deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"comment": `comment__s6u9p`,
	"commentUserAvatar": `commentUserAvatar__SebBT`,
	"commentHead": `commentHead__uxity`,
	"commentDate": `commentDate__X0qxS`,
	"translateBtn": `translateBtn__bvEvv`,
	"translateBtnText": `translateBtnText__vJ4bd`,
	"translateIcon": `translateIcon__HOOy0`,
	"commentInfo": `commentInfo__kBm1f`,
	"commentAuthor": `commentAuthor__LJtoj`,
	"commentEdited": `commentEdited__a1e0r`,
	"commentBody": `commentBody__raH24`,
	"commentBodyFiles": `commentBodyFiles__xqAub`,
	"fileItem": `fileItem__A6kJ2`,
	"fileItemName": `fileItemName__Gprab`,
	"commentMessage": `commentMessage__fcCBr`,
	"commentActions": `commentActions__bAVeK`,
	"editCommentIcon": `editCommentIcon__f_EFK`,
	"extraBlock": `extraBlock__wVqtT`,
	"arrowIcon": `arrowIcon__NsbOv`,
	"arrowTop": `arrowTop__Dxo9l`
};
module.exports = ___CSS_LOADER_EXPORT___;
